import * as React from 'react';

import { dropdownListItemLeftAligned, dropdownListItemRightAligned } from './FilterPanelStyles';


export function ListItemContentWithCount(props: { label: string, count: number }) {
  return <>
    <span className={dropdownListItemLeftAligned}>{props.label}</span>
    <span className={dropdownListItemRightAligned}>{props.count}</span>
  </>;
}